import { useStore } from 'vuex'

export default function useContent () {
  const { state } = useStore()

  function highlightName (content) {
    return content
      .replaceAll(state.user.name, `<span class="mentioned-name">${state.user.name}</span>`)
      .replaceAll(state.user.nickname, `<span class="mentioned-name">${state.user.nickname}</span>`)
  }

  return {
    highlightName
  }
}
